import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserAuth } from "./context/UserAuthContext";

const ProtectedRoute = () => {
    const { Token, logOut } = useUserAuth();
    const location = useLocation();

    const invalidToken =
        !Token ||
        String(Token).trim() === "" ||
        String(Token) === "0" ||
        String(Token).toLowerCase() === "null" ||
        String(Token).toLowerCase() === "undefined";

    if (invalidToken) {
        console.warn("Missing or invalid token");
        if (typeof logOut === "function") {
            logOut();
        }
        return <Navigate to="/auth/sign-in" replace state={{ from: location }} />;
    }

    return <Outlet />;
};

export default ProtectedRoute;